// Brand logo — renders either an uploaded company logo (src prop or
// tenant.logoUrl) OR the default stylized bar chart in a rounded square.
import React from 'react';

export function Logo({ size = 32, className = '', src, alt = 'Logo' }) {
  // Custom logo uploaded by the tenant admin.
  if (src) {
    return (
      <div
        className={`inline-flex items-center justify-center rounded-[8px] overflow-hidden bg-white border border-neutral-200 ${className}`}
        style={{ width: size, height: size }}
      >
        <img src={src} alt={alt} style={{ width: '100%', height: '100%', objectFit: 'contain' }}/>
      </div>
    );
  }

  // Default bar-chart mark — animated.
  // sc-logo-frame: gentle float + replays bar grow on hover.
  // sc-logo-bar:   each bar grows from baseline on mount (stagger via .sc-bar-N).
  // sc-logo-arrow: trend lines draw in after the bars settle.
  return (
    <div
      className={`sc-logo-frame inline-flex items-center justify-center rounded-[8px] ${className}`}
      style={{
        width: size,
        height: size,
        background: 'linear-gradient(135deg, #305496 0%, #2E74B5 100%)',
      }}
      aria-label="Sales Commission logo"
    >
      <svg viewBox="0 0 24 24" width={size * 0.6} height={size * 0.6} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-white">
        <rect className="sc-logo-bar sc-bar-1" x="4"  y="14" width="3" height="6"  rx="0.5" fill="currentColor" stroke="none"/>
        <rect className="sc-logo-bar sc-bar-2" x="10" y="10" width="3" height="10" rx="0.5" fill="currentColor" stroke="none"/>
        <rect className="sc-logo-bar sc-bar-3" x="16" y="6"  width="3" height="14" rx="0.5" fill="currentColor" stroke="none"/>
        <path className="sc-logo-arrow" d="M3 9l6-4 4 3 7-5"/>
        <path className="sc-logo-arrow" d="M15 3h5v5"/>
      </svg>
    </div>
  );
}

// Inline "logo + wordmark" pair used in top-bars.
export function Logomark({ size = 28, subtitle, className = '' }) {
  return (
    <div className={`inline-flex items-center gap-2.5 ${className}`}>
      <Logo size={size}/>
      <div className="leading-tight">
        <div className="text-[14px] font-semibold text-neutral-900 tracking-[-0.01em]">
          Commissions <span className="text-neutral-500 font-normal">by</span> Staffology
        </div>
        {subtitle && <div className="text-[11px] text-neutral-500">{subtitle}</div>}
      </div>
    </div>
  );
}
